import { HttpClient } from "@angular/common/http";
import { Component, Input, OnChanges, OnInit } from "@angular/core";
import {
  ControlContainer,
  UntypedFormBuilder,
  UntypedFormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { environment } from "@environments/environment";
import { CanvasService } from "@services/canvas.service";
import { CommonService } from "@services/common.service";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";

@Component({
    selector: "app-formating",
    templateUrl: "./formating.component.html",
    styleUrls: ["./formating.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class FormatingComponent implements OnInit, OnChanges {
  constructor(
    public parentF: FormGroupDirective,
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    public commonService: CommonService,
    private canvasService: CanvasService
  ) {}
  @Input() chartType!: any;
  @Input() formatdata!: any;
  @Input() isComponentOpen!: any;
  @Input() chartData!: any;
  public fieldForm!: UntypedFormGroup;
  public childForm: any;
  public aggregateData: any = [];
  public reportTitle!: string;
  public editForm!: UntypedFormGroup;

  field: any;
  auto: any;
  color: any;
  fieldData: any;
  fieldsHidden: boolean = false;
  message: string = "Are you sure?";
  name: string = "";
  type: string = "";
  public formFields: any[] = [];
  faExclamationTriangle = faExclamationTriangle;

  buildAggregateData() {
    Object.keys(this.editForm.controls).forEach((key, index) => {
      if (this.editForm.get(key)!.value) {
        this.field[index].value = this.editForm.get(key)!.value;
      }
    });
    this.aggregateData = this.commonService.generateFormatters(this.field);
    this.childForm
      .get("formatdata")!
      .setValue(this.aggregateData, { emitEvent: false });

    let chartData = JSON.parse(JSON.stringify(this.chartData));
    this.locallyChangChartFormatting(chartData);
  }

  locallyChangChartFormatting(chartData: any) {
    this.formFields.forEach((field) => {
      this.editForm
        .get(field.name)!
        .setValue(field.value, { emitEvent: false });
      switch (field.name) {
        case "titleValue":
          if (this.chartType != "Table" && this.chartType != "List")
            chartData.chartObject.title.text = field.value;
          else chartData.title = field.value;
          break;
        case "subtitleValue":
          if (this.chartType != "Table" && this.chartType != "List")
            chartData.chartObject.subtitle.text = field.value;
          else chartData.description = field.value;
          break;
        case "xAxisValue":
          chartData.chartObject.xAxis.title.text = field.value;
          break;
        case "yAxisValue":
          chartData.chartObject.yAxis.title.text = field.value;
          break;
        case "legendValue":
          let legendValue = false;
          if (field.value) legendValue = true;
          chartData.chartObject.legend.enabled = legendValue;
          break;
        case "showTooltipValue":
          let showTooltipValue = false;
          if (field.value) showTooltipValue = true;
          chartData.chartObject.tooltip.enabled = showTooltipValue;
          break;
        case "showDataLabelsValue":
          let showDataLabelsValue = false;
          if (field.value) showDataLabelsValue = true;
          chartData.chartObject.plotOptions[
            this.chartType.toLowerCase()
          ].dataLabels.enabled = showDataLabelsValue;
          break;
      }
    });
    chartData.modifications.data.formatters.data = this.formFields;
    this.canvasService.populateCanvas(chartData);
  }
  getaDatFormattingFields(type: string) {
    this.http
      .get(
        environment.enterpriseUrls.apiEndpoint +
          "/charts/formatters?chartType=" +
          type
      )
      .subscribe((suc: any) => {
        this.formFields = suc.data;
        this.field = suc.data;
        this.generateForm();
      });
  }

  generateField(field: any, index: number) {
    let value = null;
    if (this.formatdata[index]) {
      value = this.formatdata[index].value;
      if (value && typeof value == "object") {
        value = this.formatdata[index].value[0];
      }
    }

    if (value || value == false) {
      if (this.editForm.get(field.name)) {
        this.editForm.get(field.name)!.setValue(value, { emitEvent: false });
      } else {
        this.editForm.addControl(field.name, this.fb.control(value));
      }
    } else {
      switch (field.displayType) {
        case "slide-toggle":
          if (this.editForm.get(field.name)) {
            if (typeof value == "undefined") {
              this.editForm
                .get(field.name)!
                .setValue(false, { emitEvent: false });
            } else {
              this.editForm
                .get(field.name)!
                .setValue(true, { emitEvent: false });
            }
          } else {
            this.editForm.addControl(field.name, this.fb.control(true));
          }
          break;
        default:
          if (this.editForm.get(field.name)) {
            this.editForm.get(field.name)!.setValue("", { emitEvent: false });
          } else {
            this.editForm.addControl(field.name, this.fb.control(""));
          }
      }
    }
  }

  generateForm() {
    this.editForm.reset();
    let forEachPromise = new Promise<void>((resolve) => {
      this.formFields.forEach((field, index, array) => {
        this.generateField(field, index);
        if (index === array.length - 1) resolve();
      });
    });

    forEachPromise.then(() => {
      this.editForm.enable();
      if (this.formatdata.length <= 0) {
        this.editForm
          .get("titleValue")!
          .setValue(this.reportTitle, { emitEvent: false });
      }
    });
  }

  initForm() {
    this.childForm = this.parentF.form;
    this.editForm = this.fb.group({});
    this.editForm.disable();
  }

  ngOnChanges(): void {
    if (this.editForm) {
      if (
        this.chartType == "textBox" ||
        this.chartType == "header" ||
        this.chartType == "footer" ||
        this.chartType == "image"
      ) {
        this.editForm.disable();
      } else {
        if (this.isComponentOpen) {
          this.editForm.disable();
          this.getaDatFormattingFields(this.chartType);
        }
        // this.editForm.enable();
      }
    }
  }

  ngOnInit(): void {
    this.childForm = this.parentF.form;
    if (this.childForm) {
      this.reportTitle = this.childForm.controls["title"].value;
    }
    this.initForm();
    if (this.isComponentOpen) {
      this.getaDatFormattingFields(this.chartType);
    }
  }
}
